import { render } from "./brand-four.vue?vue&type=template&id=6a0720cc"
import script from "./brand-four.vue?vue&type=script&lang=js"
export * from "./brand-four.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__